// extracted by mini-css-extract-plugin
export default {"wrap":"YH-z","fullWidth":"ZH-z","hideOnDesktop":"_H-z","content":"aI-z","hasOpenedNav":"bI-z","crumbsList":"cI-z","dropdownsWrap":"dI-z"};